export default function stripeCheckoutButton(sessionId, publicKey) {
    if (Stripe) {
        var stripe = Stripe(publicKey)
        stripe.redirectToCheckout({
            sessionId: sessionId
        }).then((result) => {
        });    
    }
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/util/stripeCheckoutButton.js
 **/